import { HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { AppMessagesService } from 'src/app/core/services/app-messages.service';
import { AppServiceService } from 'src/app/core/services/app-service.service';
import { SiteStettingService } from 'src/app/core/services/site-stetting.service';

@Component({
  selector: 'app-login-via-otp',
  templateUrl: './login-via-otp.component.html',
  styleUrls: ['./login-via-otp.component.scss']
})
export class LoginViaOtpComponent implements OnInit {
  @Output() loginViaPassword = new EventEmitter();
  varTarget:any;
  idCardForm: FormGroup;
  verificationCodeForm: FormGroup;
  //לשנות...
  restartcode: boolean;
  showVerificationCode: boolean = false;
  phoneNumberWithAsterisks: string;
  verificationCodeInvalid: boolean;
  sitekey: string;
  CaptchaNeeded:boolean;
  message:string="";
  links:any;
  updatePhone:string;
  showUpdatePhone:boolean = true;
  loader:boolean = false;
  HTMLContent = "<p>כדי שנוכל לזהות אותך, אנו זקוקים לכל 9 הספרות של ת.ז שלך, כולל ספרת ביקורת. אם אין לך ת.ז, אנו זקוקים למספר הדרכון שלך המורכב מ 16 ספרות ואותיות.</p>";
  service : any;
  title: string = 'כניסה עם קוד חד פעמי לנייד'
  isValidFormSubmitted : boolean = false;
  constructor(private formBuilder: FormBuilder , private activatedRoute :ActivatedRoute, private appService:AppServiceService
    , private _siteSettingService: SiteStettingService, private _router: Router , private appMessagesService :AppMessagesService , private appConfigService:AppConfigService) { }
  @Input() otp = '';

  get verificationCode() {
    return this.verificationCodeForm.controls.verificationCode;
  }
  ngOnInit(): void {
    document.getElementById("otp").focus({ preventScroll: true });
    if(window['_loginType'] == window['_loginTypeUsernamePasswordSMSOTP']){
      this.title = 'הזדהות משרד החינוך'
      this.showUpdatePhone = false;
    }
    this.service = this.appConfigService.service;
    this.appService.componentName = 'login-via-otp-component';
    if(window['_loginType'] == window['_loginTypeOTPOnly'] || window['_loginType'] == window['_loginTypeUsernamePasswordSMSOTP']){
        this.otp = this.appService.mobileOtp;
    }
    this.appConfigService.getLinks().subscribe(
      (data) => {
        this.links = data;
      },
      (error)=>{
        //TODO
      })
    this.updatePhone = this.links.updateDetails;
    this.CaptchaNeeded = this._siteSettingService.CaptchaNeeded;
    this.sitekey = window['_siteSettings'].recaptchaSiteKey;
    this.verificationCodeForm = this.formBuilder.group({
      verificationCode: new FormControl('', { validators: [Validators.required] }),
    });
  }
  login(){
    
  }
  checkVerificationCode(captchaResponse?: any) {
    this.isValidFormSubmitted = true;
    if (this.verificationCodeForm.invalid) {
      grecaptcha.reset();
      document.getElementById("otp").focus();
       return;
    }
    this.loader = true;
    if(captchaResponse == undefined)
    captchaResponse = " ";
    this.service.sendOtp(this.verificationCodeForm.value.verificationCode , captchaResponse).subscribe(data => {
if(data)
{
  this.CaptchaNeeded = this._siteSettingService.CaptchaNeeded = data.isCaptchaNeeded;
      if (data.isError == false){
        this.appService.redirectTourl();    
      }
      else {
       
          if(data.errorCode =='INTRUDER_DETECTED'){
            this.appMessagesService.errorCode = data.errorCode ;
             this.loader = false;
          this._router.navigate(['locked'], { skipLocationChange: true });
          
        }
        else
        {
          if (data.errorCode == 'TOKEN_TOKEN_EXPIRED') {
            this.message = this.appMessagesService.returnErrorMessage('TOKEN_NOT_FOUND')
            }
           else
           { 
             this.message = this.appMessagesService.returnErrorMessage(data.errorCode);
            }
        this.loader = false;      
        this.verificationCodeForm.reset();
        grecaptcha.reset();
        document.getElementById("otp").focus();
        this.isValidFormSubmitted = false;
      }      
    }
      }
    }, err => {
     
    }).add(() => {
  //     setTimeout(()=>{ 
  //       this.message = "";                          
  //  }, 5000);
    });;
  }
  loginByPassward() {
    this.loginViaPassword.emit();
  }

  resetMassage(){
    this.message = "";
  }

  back(){
        this.appService.doReset(); 
  }
}
